import { render, staticRenderFns } from "./Lgx368769034444865536.vue?vue&type=template&id=2c412fe6&scoped=true&"
import script from "./Lgx368769034444865536.vue?vue&type=script&lang=js&"
export * from "./Lgx368769034444865536.vue?vue&type=script&lang=js&"
import style0 from "./Lgx368769034444865536.vue?vue&type=style&index=0&id=2c412fe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c412fe6",
  null
  
)

export default component.exports